import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

const key = (companyId) => ['limitsPermit', companyId];

const getLimitsPermit = async ({ queryKey }) => {
  const [_, companyId] = queryKey;

  return await request.get(
    `/Access/transport/company/${companyId}/permit`,
    null,
    'При получении списка лимитов произошла ошибка'
  );
};

const useLimitsPermitQuery = (companyId, options) =>
  useQuery(key(companyId), getLimitsPermit, options);

export default useLimitsPermitQuery;
